import React, { Component } from "react";
import { Spin, message, Radio, Space } from "antd";
import Bridge from "../../../utils/Bridge";
import { logEvent } from "../../../utils/analytics";
import dayjs from "dayjs";
import moment from "moment";
import { speech_demographics_form_type } from "../../../utils/consts";

export default class FamilyHistoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      positive_family_history: "",
      relationship:"",
      email:"",
      neurostamp_id:"",
      modality_id:"",
      field_data:[]
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.family_history;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
       
        if (response.status == "1") {
          let arr=[]
          this.setState({
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
            field_data: response.field_data.family_history
          })
          for(let item of response.data){
            if(item.field=='FAMHXALS'){
              this.setState({
                positive_family_history:item.value
              })
            }
            if(item.field=='FAMHXFM'){
              this.setState({
                relationship:item.value
              })
            }
          }
          this.setState({loading:false})
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  // step 1
  save_details = () => {
    if (!this.state.positive_family_history) {
      message.warning("please select option of 'Do You Have A Positive Family History For ALS Or Any Other Neurodegenerative Disease' field");
      return;
    }
    if (this.state.positive_family_history=='1' && !this.state.relationship) {
      message.warning("Please, indicate relationship, disease, and age of onset");
      return;
    }
    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='FAMHXALS'){
        let obj={
          value:this.state.positive_family_history,
          view_name:item.view_name,
          form:"Family History",
          field: item.field
        }
        questions.push(obj) 
      }
      if(item.field=='FAMHXFM'){
        let obj={
          value:this.state.relationship,
          view_name:item.view_name,
          form:"Family History",
          field: item.field
        }
        questions.push(obj) 
      }
    }
    let params = {
      data: JSON.stringify(questions),
      step: speech_demographics_form_type.family_history,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_submitted", { step: "family_history" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                window.location.assign("/dashboard");
                // this.props.set_active_step(9);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Family History</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
          <div className="form-group">
              <label className="mb-2">
                Do You Have A Positive Family History For ALS Or Any Other
                Neurodegenerative Disease (Frontotemporal Dementia, Parkinson’s
                Disease, Alzheimer’s Disease)?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({ positive_family_history: event.target.value,relationship:"" })
                }
                value={this.state.positive_family_history}
              >
                <Space direction="horizontal">
                  <Radio value={"1"}>Yes</Radio>
                  <Radio value={"2"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2">
                If yes, please indicate the relationship (mother, father, sibling etc…), the disease, and the approximate age of onset of disease symptoms:
              </label>
              <br />
              <input
                type={"text"}
                value={this.state.relationship}
                onChange={(e) =>
                  this.setState({ relationship: e.target.value })
                }
                style={{
                  background: this.state.positive_family_history!='1' ? '#d9d9d9' : '#fff'
                }}
                disabled={this.state.positive_family_history!='1' ? true : false}
                placeholder="Please, indicate relationship, disease, and age of onset"
              />
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    // background: "#b3b3b3",
                    // cursor: "auto",
                  }}
                  onClick={() => {
                    logEvent("demographics_previous", { step: "family_history" });
                    if(this.props.is_non_als_user==true){
                      this.props.set_active_step(7);
                    }else{
                      this.props.set_active_step(9);
                    }
                  }}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
